import React from "react";
import { Link } from "react-router-dom";

import "./styles/footer.css";

const Footer = () => {
	return (
		<React.Fragment>
			<div className="footer">
				<ul className="footer-links">
					<li className="footer-links-item">
						<Link to="/">Home</Link>
					</li>
					<li className="footer-links-item">
						<Link to="/about">About</Link>
					</li>
					<li className="footer-links-item">
						<Link to="/projects">Projects</Link>
					</li>
					<li className="footer-links-item">
						<Link to="/resume">Resume</Link>
					</li>
					<li className="footer-links-item">
						<Link to="/contact">Contact</Link>
					</li>
				</ul>
				<div className="footer-credits">
					<div className="footer-credits-text">
						© 2024 Mengyun Xie
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
